import * as _ from 'underscore';
import { ColumnWidths } from '../models/ColumnWidths';
import { ITemplate } from '../models/ITemplate';
import { Module } from '../Module';

interface IDataGridHeadersScope extends ng.IScope {
  columnWidths: ColumnWidths;
  headerClicked: (locals: { header: ITemplate }) => any;
  headers: ITemplate[];
  headerWidthsChanged: (locals: { headerWidths: number[] }) => any;
  resize: (xPos: number) => void;
}

Module.instance().directive('tbDataGridHeaders', [
  '$timeout',
  ($timeout: ng.ITimeoutService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'dataGridHeaders.html',
      scope: {
        columnWidths: '=',
        headerClicked: '&',
        headers: '=',
        headerWidthsChanged: '&'
      },
      link: (scope: IDataGridHeadersScope, element: JQuery) => {
        scope.resize = (xPos: number) => {
          scope.$apply(() => {
            scope.columnWidths.resizer.continueResize(xPos);
          });
        };

        scope.$watch('headers', (headers: ITemplate[]) => {
          if (headers && headers.length > 0) {
            $timeout(() => {
              const headerWidths = _.map(element.find('.tb-data-grid-header'), (header: Element) => {
                const rect = header.getBoundingClientRect();
                return Math.ceil(rect.right - rect.left); // to correct for non-integer widths
              });
              scope.headerWidthsChanged({ headerWidths: headerWidths });
            });
          }
        });
      }
    };
  }
]);
